import React from 'react';
import TenderEvalTable from './TenderEvalTable';

const HydrocarbonCondensat = ({ refreshTrigger }) => (
  <TenderEvalTable procurementTypeHeader='2' refreshTrigger={refreshTrigger} />
);

export default HydrocarbonCondensat;
